/* @flow */
import { getQueryParams } from 'trustar/utils';

import type { OptionsObject } from './constants.js';
import {
  FETCH,
  SAVE,
  DELETE,
  RESET_QUOTA,
  SET_DISPLAY_OPTIONS,
} from './action-types.js';
import { Options } from './types.js';

export const fetch = (payload: Object = getQueryParams()) => ({
  type: FETCH,
  payload,
});

/**
 * Fetch companies and provide all defaults to the fetch request. This is useful
 * for situations where you just want to specify one option anjd leave the rest
 * to be defaults. Example:
 *
 *    fetchWithDefaults({ query: 'search text' })
 *
 */
export const fetchWithDefaults = (obj: Object = {}) => ({
  type: FETCH,
  payload: getQueryParams(Options(obj)), // See NOTE
});

export const setDisplayOptions = (options: OptionsObject) => ({
  type: SET_DISPLAY_OPTIONS,
  payload: options
});

export const saveCompany = (company: Object) => ({
  type: SAVE,
  payload: company,
});

export const deleteCompany = (id: string) => ({
  type: DELETE,
  payload: id,
});

/**
 * Reset the API request quota for a company by its ID
 */
export const resetQuota = (companyGuid: string, quotaId: string) => ({
  type: RESET_QUOTA,
  payload: { companyId: companyGuid, quotaId: quotaId },
});



// WEBPACK FOOTER //
// ./src/app/modules/companies/actions.js